import { Stack, Typography } from "@mui/material"

export const InterviewReminders = () => {
    return (<>
        <Stack alignItems='center' justifyContent='center' height={'100%'}>
            <Typography variant="h6">Setup Interview reminders</Typography>
            <Typography variant="subtitle1">Coming Soon!</Typography>
        </Stack>
    </>)
}